/* How the people list and sheet show where someone is known. A Definable account is one
   subject on the web app and the extension alike, so it shows as our apps do. */

import { catalogFor } from "@/shared/lib/interface-catalog";
import type { InterfaceType, KnownOn } from "@/shared/types";

const ACCOUNT = "definable";

/** The glyph it shows: a Definable account shows as the client app. */
export const glyphOf = (type: KnownOn): InterfaceType => (type === ACCOUNT ? "web" : type);

/** What it is called: "Definable account", "WhatsApp"… */
export const nameOf = (type: KnownOn): string =>
  type === ACCOUNT ? "Definable account" : catalogFor(type)?.name ?? type;
